var o = ":host,:root{--gator-menu-dropdown-max-width: 400px}";
export { o as default };